import React from "react";
import MultiSelect from "../../../utils/MultiSelectMUI";

const AssigmentUi = ({ openAssignmentPopup, lenderData, lenderChangeHadler, submitLenderAssignment, value }) => (


    <div className="background-blur-external">
        <div className="popup-contact-us text-center" style={{ height: 'auto' }}>
            <i className="fa fa-close" onClick={() => openAssignmentPopup('close')} style={{ float: 'right', cursor: 'pointer' }}></i>

            <div className="row">
                <h5> Assign Lender</h5>
                <div className="col-sm-2 col-xs-12"></div>
                {console.log(lenderData, "   lennnnnn   ", value)}
                <div className="col-sm-8 col-xs-12">
                    <MultiSelect
                        label={"Select Lender"}
                        onChange={(e) => lenderChangeHadler(e)}
                        value={value ? value :[]}
                        inputData={lenderData}/>

                    <div style={{ marginTop: '20px' }}>
                        <button className="cred-btn" onClick={() => submitLenderAssignment()}>Save</button>
                    </div>
                </div>
                <div className="col-sm-2 col-xs-12"></div>

            </div>
        </div>

    </div>
)
export default AssigmentUi